import { Icon } from '@/general/Icons/Icon';
import { FC } from 'react';


import { ButtonIcon } from '../Button/ButtonIcon';
import { FormHeader } from '../FormHeader/FormHeader';

type PersonalizedQuoteHeaderProps = {
  onContactCarma?: () => void;
  onClickCarmaLogo: () => void;
  onCloseQuote: () => void;
  /** Progress of the checkout, should be a value between 0 and 1 */
  progressStep: number;
};

export const PersonalizedQuoteHeader: FC<PersonalizedQuoteHeaderProps> = ({
  onContactCarma,
  progressStep,
  onClickCarmaLogo,
  onCloseQuote,
}) => {
  const rightComponent = (
    <div className="flex items-end gap-2">
      {!!onContactCarma && (
        <ButtonIcon
          size="small"
          title="Chat to Carma"
          variant="primary"
          styling="round"
          onClick={onContactCarma}
          data-testid="PERSONALIZED_QUOTE_HEADER_CHAT_BUTTON"
          icon={<Icon name="headset" />}
        />
      )}
      <ButtonIcon
        size="small"
        title="Close"
        variant="tertiary"
        styling="round"
        onClick={onCloseQuote}
        data-testid="PERSONALIZED_QUOTE_HEADER_CLOSE_BUTTON"
        icon={<Icon name="close" />}
      />
    </div>
  );

  return (
    <>
      <FormHeader onClickCarmaLogo={onClickCarmaLogo} progressStep={progressStep} rightComponent={rightComponent} />
    </>
  );
};
